/**
 * Created by linjianxi on 2016/10/29.
 */
export const initCardBind = (state) => {
  return state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/card_bind/getter.js